import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Enum } from 'app/model/enum';
import { RelatorioRecadastramentoService } from 'app/service/relatorio-recadastramento/relatorio.service';
import { Chart } from 'chart.js';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import * as ExcelJS from 'exceljs';
import * as fs from 'file-saver';
import { PeriodoData } from "../../model/periodoData.dto";
import * as moment from "moment";

@Component({
  selector: 'app-relatorio-sintetico-recadastramento',
  templateUrl: './relatorio-sintetico-recadastramento.component.html',
  styleUrls: ['./relatorio-sintetico-recadastramento.component.sass']
})
export class RelatorioSinteticoRecadastramentoComponent implements OnInit {
  @ViewChild('sinteticoChart', { static: true }) chartCanvas: ElementRef;

  form: FormGroup;
  chart: Chart;
  chartPizza: Chart;
  anos: number[] = [];
  existeGrafico: boolean = false;
  showDownloadButton: boolean = true;
  @Output() voltarPagina: EventEmitter<void> = new EventEmitter<void>();
  exececoesService: any;
  relatorioSintetico: any;

  constructor(private toastrService: ToastrService, private formBuilder: FormBuilder, private relatorioService: RelatorioRecadastramentoService,) { }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      ano: ['', [Validators.required]],
      dataInicio: ['', [Validators.required]],
      dataFim: ['', [Validators.required]],
    });
    this.tipoCampanha()
  }

  ngOnDestroy(): void {
    if (this.chart) {
      this.chart.clear();

      this.chart.destroy();
    }
  }
  checkDiffData() {
    if (this.form.value.dataFim < this.form.value.dataInicio && this.form.value.dataFim != '' && this.form.value.dataFim != null) {
      this.existeGrafico = false;
      this.toastrService.warning("Data de inicio maior que data fim.")
      this.form.controls.dataFim.reset()
    }
  }

  periodoCampanha() {
    if (this.form.controls.ano.status == 'VALID') {
      this.relatorioService.periodoCampanho(this.form.value.ano).subscribe((periodoCampanha: any) => {
        this.preencherCamposData(periodoCampanha);
      },
        (error) => {
          console.error(error);
        }
      );
    }
  }

  private preencherCamposData(data: PeriodoData) {
    if (data?.dataInicio && data?.dataFim) {
      const dataInicio = moment(data.dataInicio).toDate();
      const dataFim = moment(data.dataFim).toDate();

      this.form.patchValue({
        dataInicio,
        dataFim
      });
    }
  }

  tipoCampanha() {
    this.getAnosDisponiveisCampanha().subscribe(
      (response) => {
        this.anos = response;
      },
      (error) => {
        console.error(error);
      }
    );
  }

  private getAnosDisponiveisCampanha(): Observable<any> {
    return this.relatorioService.anosCampanha();
  }

  filtarGraficoSintetico() {
    this.checkDiffData();
    if (this.form.valid) {
      const dataInicio = this.form.get('dataInicio').value;
      const dataFim = this.form.get('dataFim').value;

      const dadosParaEnviar = {
        dataInicio: new Date(dataInicio).toISOString().slice(0, 10),
        dataFim: new Date(dataFim).toISOString().slice(0, 10),
        ano: this.form.value.ano
      };
      this.existeGrafico = false;

      this.relatorioService.dadosRelatorioSintetico(dadosParaEnviar).subscribe((dadosRelatorio: any) => {
        console.log(dadosRelatorio)
        if (dadosRelatorio.totalGeral == 0) {
          this.existeGrafico = false;
          this.showDownloadButton = true
          this.toastrService.warning('Não foram encontrados recadastramentos realizados neste período!')
          return
        }
        this.existeGrafico = true;
        const relatorioSintetico = dadosRelatorio.relatorioSintetico;
        if (dadosRelatorio.totalGeral > 0) {
          this.showDownloadButton = false
        } else {
          this.showDownloadButton = true
        }

        this.relatorioSintetico = dadosRelatorio;
        const labels = relatorioSintetico
        .map(item => item.data); // Extrair as datas dos objetos filtrados


        const relatoriosComData = relatorioSintetico.map(objeto => objeto.data !== null);

        // Criar os arrays de data finalizada e não finalizada a partir dos objetos filtrados
        const dataFinalizados = relatorioSintetico.map(item => item.qntFinalizados);
        const dataNaoFinalizados = relatorioSintetico.map(item => item.qntNaoFinalizados);
        const planejada = relatorioSintetico.map(item => item.porcentagemPlanejada);


        if (this.chart) {
          this.chart.data.labels = []; // Limpa os rótulos
          this.chart.data.datasets = []; // Limpa os conjuntos de dados
          this.chart.destroy(); // Destrói a instância antiga
        }

        const ctx = document.getElementById('sinteticoChart') as HTMLCanvasElement;
        this.chart = new Chart(ctx, {
          type: 'line', // Alteração do tipo de gráfico para 'line'
          data: {
            labels: labels.map(label => label !== null ? label : ''),
            datasets: [
              {
                label: 'Finalizados',
                borderColor: 'rgba(75, 192, 192, 1)', // Cor da borda da linha
                backgroundColor: 'rgba(75, 192, 192, 0.2)', // Cor de fundo da área sob a linha
                fill: false, // Preenchimento da área sob a linha
                data: dataFinalizados,
              },
              {
                label: 'Não Finalizados',
                borderColor: 'rgba(255, 99, 132, 1)', // Cor da borda da linha
                backgroundColor: 'rgba(255, 99, 132, 0.2)', // Cor de fundo da área sob a linha
                fill: false, // Preenchimento da área sob a linha
                data: dataNaoFinalizados,
              },
              {
                label: 'Planejada',
                borderColor: 'rgba(23, 34, 132, 1)', // Cor da borda da linha
                backgroundColor: 'rgba(255, 99, 132, 0.2)', // Cor de fundo da área sob a linha
                fill: false, // Preenchimento da área sob a linha
                data: planejada,
              },
            ],
          },
        });
        // this.chart = new Chart(ctx, {
        //   type: 'bar',
        //   data: {
        //     labels: labels,
        //     datasets: [
        //       {
        //         label: 'Finalizados',
        //         backgroundColor: 'rgba(75, 192, 192, 0.5)',
        //         data: dataFinalizados
        //       },
        //       {
        //         label: 'Não Finalizados',
        //         backgroundColor: 'rgba(255, 99, 132, 0.5)',
        //         data: dataNaoFinalizados
        //       }
        //     ]
        //   }


        // });


      },
        (error) => {
          console.error(error);
        }
      );
    }
  }

  async downloadExcelRelatorioSintetico() {
    if (!this.relatorioSintetico || this.relatorioSintetico.length === 0) {
      return; // Não gera o relatório se não houver dados
    }
    this.toastrService.info('Baixando arquivo. Por favor, aguarde!');

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('RelatorioSintetico');

    const titleFont = {
      name: 'Arial',
      size: 11,
      bold: true,
      color: { argb: 'FFFFFF' }
    };

    const boldContentFont = {
      name: 'Arial',
      size: 9,
      bold: true
    };

    const contentFont = {
      name: 'Arial',
      size: 9
    };

    // Crie os títulos das colunas
    const headerRow = worksheet.addRow(['Data', 'Quantidade Finalizados', 'Quantidade Não Finalizados', 'Total']);
    headerRow.eachCell(cell => {
      cell.font = titleFont;
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '2187E5' }
      };
      cell.alignment = { vertical: 'middle', horizontal: 'center' };
    });

    // Adicione os dados
    this.relatorioSintetico.relatorioSintetico.forEach(item => {
      const row = worksheet.addRow([
        item.data,
        item.qntFinalizados,
        item.qntNaoFinalizados,
        item.totalData
      ]);
      row.eachCell(cell => {
        cell.font = contentFont;
        cell.alignment = { vertical: 'middle', horizontal: 'center' };
      });
    });

    // Pule uma linha antes de adicionar os totais
    worksheet.addRow([]);

    // Adicione os totais no final (em linhas separadas)
    const totalsData = [
      ['Total finalizados Porcentagem', this.relatorioSintetico.totalFinalizadosPercentagem],
      ['Total finalizados', this.relatorioSintetico.totalFinalizados],
      ['Total Não finalizados', this.relatorioSintetico.totalNaoFinalizados],
      ['Total Geral', this.relatorioSintetico.totalGeral]
    ];
    totalsData.forEach(rowData => {
      const row = worksheet.addRow(rowData);
      row.eachCell(cell => {
        cell.font = boldContentFont;
        cell.alignment = { vertical: 'middle', horizontal: 'center' };
      });
    });

    // Ajuste a largura das colunas
    worksheet.columns.forEach(column => {
      column.width = 30; // Ajuste o valor conforme necessário
    });

    // Crie um Blob do arquivo Excel
    const blob = await workbook.xlsx.writeBuffer();

    // Inicie o download do arquivo
    const filename = 'relatorio_sintetico.xlsx';
    fs.saveAs(new Blob([blob]), filename);
    this.toastrService.clear()
    this.toastrService.success('Arquivo baixado!');

  }
}
